export default function LatestRaceWidget(){

  if(!$('.home-standings').hasClass('standings-disabled')){
    const driversAssets = smx_data.driversAssets
    const driverDefaultImage = smx_data.driverDefaultImage
    const timeStamp = Date.now()
    let RaceTitle = ``

    function getDriverIndex(targetDriver) {
      targetDriver = targetDriver.trim()
      let driverIndex, driverName;
      driversAssets.forEach(driver => {
        driverName = driver.name.replace(' ', '-').toLowerCase().trim()
        if (driverName === targetDriver) {
          driverIndex = driversAssets.indexOf(driver);
          return false;
        } 
      })
      if (driverIndex !== undefined){
        return driverIndex
      } else {
        return 'default'
      }
    }

    function getDriverImage(driver){
      let driverIndex = getDriverIndex(driver)
      if(driverIndex === 'default'){
        return driverDefaultImage
      } else{
        return driversAssets[driverIndex].image
      }
    }

    function getDriverNationality(driver){
      let driverIndex = getDriverIndex(driver)
      if(driverIndex === 'default'){
        return '<span class="fi fi-${getDriverNationality(nameSlug)} fis driver-flag hide"></span>'
      } else{
        return `<span class="fi fi-${driversAssets[driverIndex].nationality} fis driver-flag"></span>`
      }
    }
    
    function latestRaceTitle() {
      $.ajax( {
        url: 'https://data-aws.amaproracing.com/api/overallresults/latest/mx/m1',
        method: 'GET',
        dataType: 'json',
        error: () => {
          console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",)
        },
        success: data => {
          const latestRaceWidgetTitleContainer = $('#latest-race-widget-title')
          RaceTitle = `${data.EventName}`
          latestRaceWidgetTitleContainer.html(RaceTitle)
        }
      });
    }

    function latestRaceTitleOld() {
      $.ajax( {
        url: 'https://live.amaproracing.com/xml/mx/RaceResults.json',
        method: 'GET',
        dataType: 'json',
        error: () => {
          console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",)
        },
        success: data => {
          const latestRaceWidgetTitleContainer = $('#latest-race-widget-title')
          RaceTitle = `${data.E}`
          latestRaceWidgetTitleContainer.html(RaceTitle)
        }
      });
    }

    function latestRaceResultsTop(url,title){
    const latestRaceWidgetContainer = $(`#latest-race-widget-${title}`)
    
    if( ! latestRaceWidgetContainer.length ) {
      return;
    }		  
      
      $.ajax( {
        url: url,
        method: 'GET',
        dataType: 'json',
        error: () => {
          console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
        },
        success: data => {		
          let container = ``
          const results = data.OverallResult
          results.sort((a,b) => (a.OverallPos > b.OverallPos) ? 1 : ((b.OverallPos > a.OverallPos) ? -1 : 0))
          $('.home-standings').removeClass('loading')
          if ( results.length ) {
            let counter = 1

            container += `<div class="race-wrapper">`
            for ( let result of results ) {
              const position = result.OverallPos <= 9 ? `0${result.OverallPos}` : result.OverallPos
              const fullName = `${result.FullName}`
              const slug = fullName.replace(/\s+/g, '-').toLowerCase()
              const points = result.OverallPoints
              const image = result.HeadshotUrl
              
              container += `<div class="racer item-450">`
              container += `  <div class="side">`
              container += `    <p class="position">${position}</>`
              container += `    <p class="name">${fullName.split(' ')[1]}</p>`
              container += `    <p class="points">${points} PTS</p>`
              container += `  </div>`
              container += `  <div class="side">`
              container += `    <img src="${image}" alt="" class="racer-photo">`
              container += getDriverNationality(slug)
              container += `  </div>`
              container += `</div>`
              
              counter++
              if (counter > 3) break
            }
            container += `</div>`
            
            latestRaceWidgetContainer.html(container)
          }

        }
      });
    }

    function latestRaceResultsTopOld(url){
    const latestRaceWidgetContainer = $(`#latest-race-widget-450`)
    
    if( ! latestRaceWidgetContainer.length ) {
      return;
    }		  
      
      $.ajax( {
        url: url,
        method: 'GET',
        dataType: 'json',
        error: () => {
          console.log("%cError fetching results!", "color: red; font-weight:700; font-size:20px;",);
        },
        success: data => {		 
          let container = ``
          const results = data.B

          if ( results.length ) {
            let counter = 1

            container += `<div class="race-wrapper">`
            for ( let result of results ) {
              const position = result.A <= 9 ? `0${result.A}` : result.A
              const fullName = `${result.F}`
              const slug = fullName.replace(/\s+/g, '-').toLowerCase().slice(0, -1)
              const points = result.OverallPoints
              const image = result.HeadshotUrl
              
              container += `<div class="racer item-450">`
              container += `  <div class="side">`
              container += `    <p class="position">${position}</>`
              container += `    <p class="name">${fullName.split(' ')[1]}</p>`
              container += `    <p class="points">${points} PTS</p>`
              container += `  </div>`
              container += `  <div class="side">`
              // container += `    <img src="${image}" alt="" class="racer-photo">`
              container += `    <img src="${getDriverImage(slug)}" alt="" class="racer-photo">`
              container += getDriverNationality(slug)
              container += `  </div>`
              container += `</div>`
              
              counter++
              if (counter > 3) break
            }
            container += `</div>`
            
            latestRaceWidgetContainer.html(container)
          }

        }
      });
    }


    latestRaceTitle()
    latestRaceResultsTop('https://data-aws.amaproracing.com/api/overallresults/latest/mx/m1', '450')
    latestRaceResultsTop('https://data-aws.amaproracing.com/api/overallresults/latest/mx/m2', '250')
    // latestRaceTitleOld()
    // latestRaceResultsTopOld('https://live.amaproracing.com/xml/xc/RaceResults.json')
  } else{
    $('.home-standings').hide()
  }

}